import { apiRequest } from '../http';
import { AuditFilters, AuditLogEntry, PagedResult } from './types';

/** Repositorio de Auditoria (Esq_Audit.TB_Audit_Log) - solo lectura. */
export class AuditRepository {
  constructor(private getToken: () => Promise<string | null>) {}

  async list(filters: AuditFilters, page: number, pageSize: number): Promise<PagedResult<AuditLogEntry>> {
    const token = await this.getToken();
    const params = new URLSearchParams();
    Object.entries({ ...filters, page: String(page), pageSize: String(pageSize) }).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params.set(key, String(value));
    });
    return apiRequest(`/api/audit/logs?${params.toString()}`, { token });
  }
}
